import React from 'react';
import { createBrowserRouter, Navigate, Outlet, RouterProvider } from "react-router-dom";
import { UserContext } from './UserContext.js';
import HomePage from './pages/home.jsx';
import PlayPage from './pages/play.jsx';
import ProjectPage from './pages/project.jsx';
import EditorPage from './pages/editor.jsx';
import SignInPage from './pages/signin.jsx';
import SignUpPage from './pages/signup.jsx';
import TutorialPage from './pages/tutorial.jsx'
import Header from './components/header.jsx';
import Navbar from './components/navbar.jsx';

const AppShell = () => (
    <>
        <Header />
        <div className='section'>
            <Navbar />
            <Outlet />
        </div>
    </>
);

const router = createBrowserRouter([
    {
        path: '/',
        element: <AppShell />,
        children: [
            { index: true, element: <HomePage /> },
            { path: 'play/:project', element: <PlayPage mode="play" /> },
            { path: 'projects', element: <ProjectPage /> },
            { path: 'edit/:project', element: <EditorPage /> },
            { path: 'signin', element: <SignInPage /> },
            { path: 'signup', element: <SignUpPage /> },
            { path: ':owner/:project', element: <PlayPage mode="shared" /> },
            { path: 'tutorial', element: <TutorialPage /> },
            { path: '*', element: <Navigate to="/" replace /> }
        ]
    }
]);

const App = ({ user }) => {
    return (
        <UserContext.Provider value={user}>
            <RouterProvider router={router} />
        </UserContext.Provider>
    );
};

export default App;
